import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Checkbox, FormControlLabel, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import EditIcon from '@mui/icons-material/Edit'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import { Item } from '../../../../common/snippets'
import DropDownOA from '../../../../common/dropDownOA'
import LineInputV3 from '../../../../common/lineInputV3'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { clickElement, focusElemnt, isEmpty, navigation1, navigation3, sortTableData } from '../../../../common/helper'
import { getMethodOfPkngTableData, methodOfPkngDataInsert } from '../../../../../store/generalSetting/GSAction'
import { updateAlertError } from '../../../../../store/common/common_action'
import { connect } from 'react-redux'
import moment from 'moment'

const MethodOfPackingTable = (props) => {
    const { data, getMethodOfPkngTableData, methodOfPkngDataInsert, updateAlertError } = props
    const { common, generalSettingReducer } = data
    const { loginData } = common
    const { methodOfPkngTblData } = generalSettingReducer
    const [order, setOrder] = useState('asc')
    const [orderBy, setOrderBy] = useState('')
    const [tableData, setTableData] = useState([])
    const [isActive, setIsActive] = useState(true)
    const [filterValues, setFilterValues] = useState({});
    const [filteredData, setfilteredData] = useState(tableData)
    const [packingMethod, setPackingMethod] = useState('')
    const [manageFocus, setManageFocus] = useState(false)

    useEffect(() => {
        getTableData()
    }, [loginData])

    const getTableData = () => {
        if (!isEmpty(loginData)) {
            let object = {
                intCompanyID: loginData?.intCompanyID,
                intUserID: loginData?.intUserID,
                intIsActive: -1
            }
            getMethodOfPkngTableData(object)
        }
    }
    useEffect(() => {
        if (methodOfPkngTblData?.length > 0) {
            const data = [...methodOfPkngTblData]
            data.sort((a, b) => {
                if (a.IsActive === b.IsActive) {
                    return a.MOPName.localeCompare(b.MOPName)
                }
                return b.IsActive - a.IsActive
            })
            let newData = data?.map((val, i) => ({ ...val, editBtn: true, packingName: val.MOPName, active: val.IsActive }))
            setTableData(newData)
        } else {
            setTableData([])
        }
    }, [methodOfPkngTblData])

    useEffect(() => setfilteredData(tableData), [tableData])

    useEffect(() => {
        const filteredDataTemp = tableData.filter((item) => {
            return columnDefs.every((column) => {
                const filterValue = filterValues[column.field] || "";
                const value = item[column.field]
                return filterValue ? value && value.toString().toLowerCase().includes(filterValue.toLowerCase()) : true
            })
        })
        setfilteredData(filteredDataTemp)
    }, [filterValues])

    useEffect(() => {
        setTimeout(() => {
            focusElemnt('mpkngMop')
        }, 0)
    }, [])

    const columnDefs = [
        { headerName: 'SN', headerSx: { minWidth: "5%" }, field: "SN", dataType: "string", showfilter: false, allowSorting: false },
        { headerName: 'Method Of Packing', headerSx: { minWidth: "23%" }, field: "packingName", dataType: "string", showfilter: true, allowSorting: false },
        { headerName: 'Modified By', headerSx: { minWidth: "29%" }, field: "UserModified", dataType: "string", showfilter: false, allowSorting: true },
        { headerName: 'Modified Date & Time', headerSx: { minWidth: "20%" }, field: "ModifiedDate", dataType: "time", showfilter: false, allowSorting: true },
        { headerName: 'Active', headerSx: { minWidth: "11%" }, field: "active", dataType: "string", showfilter: false, allowSorting: false },
        { headerName: 'Edit', headerSx: { minWidth: "12%" }, field: "Edit", dataType: "string", showfilter: false, allowSorting: false },
    ]

    const handleAdd = () => {
        if (packingMethod === '') {
            updateAlertError({ show: true, msg: 'Please Enter The Method Of Packing', success: false, nextId: 'mpkngMop' })
            return
        } else {
            let obj = {
                MOPID: 0,
                CompanyID: loginData?.intCompanyID,
                MOP: packingMethod,
                IsActive: isActive ? 1 : 0,
                UserID: loginData?.intUserID
            }
            methodOfPkngDataInsert(obj)?.then((res) => {
                if (res?.status == 'Success') {
                    updateAlertError({ show: true, msg: 'Method Of Packing Created', success: true, close: resetValues(), nextId: 'mpkngMop' })
                } else {
                    updateAlertError({ show: true, msg: res.Message, success: false, nextId: 'mpkngMop' })
                }
            }).catch((err) => {
                console.log("Error:", err)
            })
        }
    }

    const handleRowEdit = (row, index) => {
        if (row?.packingName === '') {
            updateAlertError({ show: true, msg: 'Please Enter The Method Of Packing', success: false, nextId: `mopPkngMethod-${index}` })
            return
        } else {
            let newVal = [...filteredData] 
            let obj = {
                MOPID: row?.MOPID,
                CompanyID: loginData?.intCompanyID,
                MOP: row?.packingName,
                IsActive: row?.active,
                UserID: loginData?.intUserID
            }
            methodOfPkngDataInsert(obj)?.then((res) => {
                if (res?.status == 'Success') {
                    updateAlertError({ show: true, msg: 'Method Of Packing Updated', success: true, close: getTableData(), nextId: 'mpkngMop' })
                    if (index >= 0 && index <= newVal?.length) {
                        newVal[index].editBtn = !newVal[index].editBtn
                        setfilteredData(newVal)
                    }
                } else {
                    updateAlertError({ show: true, msg: res.Message, success: false, nextId: `editBtn-${index}` })
                }
            }).catch((err) => {
                console.log("Error:", err)
            })
        }
    }

    const sortTable = (e, field, sortOrder, type) => {
        e.stopPropagation();
        setOrder(sortOrder);
        setOrderBy(field);
        const sortedData = sortTableData(e, field, sortOrder, type, tableData)
        setTableData(sortedData);
    }
    const handleRowChkChange = (e, index) => {
        setManageFocus(false)
        let newVal = [...filteredData]
        if (index >= 0 && index <= newVal?.length) {
            newVal[index].active = e.target.checked ? 1 : 0
            setfilteredData(newVal)
        }
        setTimeout(() => {
            focusElemnt(`chkbox-${index}`)
        }, 0)
    }

    const handleChangeContain = (e, name) => {
        let value = e.target.value;
        setFilterValues((prevFilterValues) => ({
            ...prevFilterValues,
            [name]: value
        }));
    }

    const handleHideEditBtn = (index) => {
        let newVal = [...filteredData]
        if (index >= 0 && index <= newVal?.length) {
            for (let i = 0; i < newVal?.length; i++) {
                if (i === index) {
                    newVal[i].editBtn = !newVal[i].editBtn
                } else {
                    newVal[i].editBtn = true
                }
            }
            setfilteredData(newVal)
            focusElemnt(`editBtn-${index + 1}`)
            newVal[index].editBtn === true ? setManageFocus(false) : setManageFocus(true)
        }
    }

    const handleCrossBtn = (index) => {
        let newVal = [...filteredData]
        if (index >= 0 && index <= newVal?.length) {
            newVal[index].packingName = filteredData[index].MOPName
            newVal[index].active = filteredData[index].IsActive
            newVal[index].editBtn = !newVal[index].editBtn
            setfilteredData(newVal)
            setTimeout(() => {
                focusElemnt(`editBtn-${index + 1}`)
            }, 0)
        }
    }

    const handleInputChange = (e, index) => {
        let newVal = [...filteredData]
        if (index >= 0 && index <= newVal?.length) {
            newVal[index].packingName = e.target.value
            setfilteredData(newVal)
        }
    }

    const resetValues = () => {
        setPackingMethod('');
        setIsActive(true);
        getTableData()
    }

    const PackagingTblRow = (props) => {
        const { item, index } = props
        return (
            <TableRow key={`foc-approval-${index}`} style={{ minHeight: '40px' }}>
                <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '5%', padding: '0px 16px 0px 16px' }}> {index + 1} </TableCell>
                {item.editBtn ? <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '23%', padding: '0px 16px 0px 16px' }}> {item.packingName} </TableCell> :
                    <TableCell className="input--wrapper" style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '23%', padding: '0px 16px 0px 16px' }}>
                        <Item sx={{ width: '100%', padding: '0px' }}>
                            <input
                                id={`mopPkngMethod-${index}`}
                                name={`mopPkngMethod-${index}`}
                                className='input--style'
                                autoFocus={manageFocus}
                                style={{ fontSize: "12px" }}
                                value={item?.packingName || ''}
                                onChange={(e) => handleInputChange(e, index)}
                                onKeyDown={(e) => { navigation1(e, `chkbox-${index}`, `checkMark-${index}`) }}
                            />
                        </Item>
                    </TableCell>
                }
                <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '29%', padding: '0px 16px 0px 16px' }}>
                    <Tooltip title={`${item.UserModified}, ${item.UserBranch}`}
                        PopperProps={{
                            sx: {
                                "& .MuiTooltip-tooltip": {
                                    backgroundColor: '#DAEDFE',
                                    color: "#000",
                                    minHeight: '26px',
                                    display: 'flex',
                                    fontWeight: '400',
                                    alignItems: "center",
                                    marginTop: '5px !important',
                                    fontSize: '12px'
                                }
                            }
                        }}
                        placement="bottom-start">
                        <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer', textDecoration: 'underline' }}>
                            {item.UserModified}
                        </span>
                    </Tooltip>
                </TableCell>
                <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '20%', padding: '0px 16px 0px 16px' }}> {moment(item.ModifiedDate).format("HH:mm") + ", " + moment(item.ModifiedDate).format('DD-MMM-YY')} </TableCell>
                <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '11%', padding: '0px 16px 0px 16px' }}>
                    <Item className="checkbox-ctrl" style={{ width: '8%', padding: '0px', backgroundColor: 'transparent' }}>
                        <FormControlLabel
                            value="end"
                            control={
                                <Checkbox
                                    id={`chkbox-${index}`}
                                    checked={item.active===1}
                                    onChange={(e) => item.editBtn ? "" : handleRowChkChange(e, index)}
                                    sx={{ fontSize: '12px', backgroundColor: 'transparent !important', height: '40px', verticalAlign: 'middle' }}
                                    onKeyDown={(e) => {
                                        navigation1(e, `checkMark-${index}`, `mopPkngMethod-${index}`)
                                    }}
                                />
                            }
                            labelPlacement="end"
                        />
                    </Item>
                </TableCell>
                <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '12%', padding: '0px 16px 0px 16px' }}>
                    {item.editBtn ? <span id={`editBtn-${index}`} tabIndex={0} style={{ display: 'flex', color: '#007bfd', fontSize: '13px', fontWeight: 'bold', width: '52px', padding: '2px 4px', marginLeft: '-6px' }}
                        onClick={() => { handleHideEditBtn(index) }}
                        onKeyDown={(e) => navigation3(e, index === filteredData?.length - 1 ? 'mpkngMop' : `editBtn-${index + 1}`, index === 0 ? "mopAddBtn" : `editBtn-${index - 1}`, () => { handleHideEditBtn(index); })}
                    >
                        <EditIcon sx={{ marginRight: '3px' }} />
                        Edit
                    </span> :
                        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap' }}>
                            <span tabIndex={0} key={`checkMark-${index}`} id={`checkMark-${index}`}
                                onClick={() => handleRowEdit(item, index)} style={{ marginRight: '5px', width: '28px', padding: '1px 1px', height: '30px', marginTop: '4px' }}
                                onKeyDown={(e) => navigation3(e, `xMark-${index}`, `chkbox-${index}`, () => {handleRowEdit(item, index)})}
                            >
                                <CheckCircleOutlinedIcon tabIndex={0} style={{ color: '#4CAF50', marginTop: '1px' }} fontSize='large' />
                            </span>
                            <span key={`xMark-${index}`} tabIndex={0} id={`xMark-${index}`}
                                onClick={() => handleCrossBtn(index)} style={{ marginRight: '5px', width: '28px', padding: '1px 1px', height: '30px', marginTop: '4px' }}
                                onKeyDown={(e) => navigation3(e, `mopPkngMethod-${index}`, `checkMark-${index}`, () => handleCrossBtn(index))}
                            >
                                <CancelOutlinedIcon tabIndex={0} style={{ color: 'red', marginTop: '1px' }} fontSize="large" />
                            </span>
                        </div>}
                </TableCell>
            </TableRow>
        )
    }
    const EmptyTableRow = () => {
        return (
            <TableRow>
                <TableCell colSpan={6}>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '15px',
                            marginBottom: '15px',
                            color: 'red',
                            fontSize: '14px',
                        }}
                    >
                        <span>No results found for the selected filters.</span>
                    </div>
                </TableCell>
            </TableRow>
        )
    }
    return (<>
        <Stack style={{ maxHeight: '60vh', marginTop: '10px' }}>
            <TableContainer className="lr-popup-table lrModel  scrollBlue" style={{ border: '1px solid #ddd', borderBottomLeftRadius: '0px' }} component={Paper}>
                <Table style={{ border: "none", overflow: 'auto' }} stickyHeader id="focApprovalTbl" className="table1 table-Received " size="small" aria-label="a dense table">
                    <TableHead style={{ position: `sticky`, top: `0`, background: `white`, zIndex: '2' }}>
                        <TableRow key='foc-tbl-header' style={{ background: '#d9edff' }}>
                            {columnDefs.map((col, index) =>
                                <TableCell key={`TH-${index}`} style={{ ...col.headerSx, backgroundColor: '#DAEDFE', minHeight: '40px', fontFamily: 'Roboto', fontSize: '12px', fontWeight: '600', color: '#444444', paddingTop: "10px", paddingBottom: "8px" }}>
                                    <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                        <span>{col.headerName}</span>
                                        {col.allowSorting &&
                                            <span className='SortingIcons'>
                                                <span
                                                    className={`up ${(orderBy === col.field && order === 'asc') ? 'active' : ''}`}
                                                    onClick={(e) => sortTable(e, col.field, "asc", col.dataType)}
                                                >
                                                    <FontAwesomeIcon icon={faCaretUp} size='lg' transform="shrink-2" />
                                                </span>
                                                <span
                                                    className={`down ${(orderBy === col.field && order === 'desc') ? 'active' : ''}`}
                                                    onClick={(e) => sortTable(e, col.field, "desc", col.dataType)}
                                                >
                                                    <FontAwesomeIcon icon={faCaretDown} size='lg' transform="shrink-2" />
                                                </span>
                                            </span>
                                        }
                                    </div>
                                </TableCell>
                            )}
                        </TableRow>
                        <TableRow key='foc-tbl-filter-row' style={{ background: '#d9edff' }}>
                            <TableCell style={{ fontSize: '12px', width: '5%' }} ></TableCell>
                            <TableCell style={{ fontSize: '12px', width: '23%' }}  >
                                <div className="filter-input" style={{ fontSize: '12px' }}>
                                    <input
                                        className="field"
                                        name="cancelSearchInput"
                                        placeholder={'Contains'}
                                        onChange={(e) => {
                                            handleChangeContain(e, 'packingName')
                                        }}
                                        style={{ width: '100%', paddingTop: '5px' }}
                                    />
                                    <FilterAltIcon />
                                </div>
                            </TableCell>
                            <TableCell style={{ fontSize: '12px', width: '29%' }} ></TableCell>
                            <TableCell style={{ fontSize: '12px', width: '20%' }} ></TableCell>
                            <TableCell style={{ fontSize: '12px', width: '11%' }} ></TableCell>
                            <TableCell style={{ fontSize: '12px', width: '12%' }} ></TableCell>
                        </TableRow>
                    </TableHead>
                    {
                        filteredData?.length > 0 ?
                            <>
                                <TableBody className="filter-data-row" style={{ border: "none" }}>
                                    {filteredData?.map((item, index) => (
                                        <PackagingTblRow item={item} index={index} key={index} />
                                    ))}
                                </TableBody>
                            </> :
                            <>
                                <TableBody>
                                    <EmptyTableRow />
                                </TableBody>
                            </>
                    }
                </Table>
            </TableContainer>
        </Stack>
        <Stack className='beachTransBottomSec' style={{ background: '#F5FAFE', top: '0px', padding: '15px 0px 11px 0px', border: '1px solid #ddd', borderTop: 'none', borderBottomLeftRadius: "6px", borderBottomRightRadius: "6px", display: 'flex', flexDirection: 'row', gap: '16px' }}>
            <Item sx={sx.itemsx} style={{ width: '4%', backgroundColor: '#F5FAFE' }}></Item>
            <Item className="input--wrapper" sx={sx.itemsx} style={{ width: '22%' }}>
                <LineInputV3
                    id='mpkngMop'
                    autoFocus
                    sx={{ width: '100%', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '400' }}
                    label={'Method Of Packing'}
                    value={packingMethod}
                    onBlur={(e) => {
                        setPackingMethod(e.target.value)
                    }}
                    onKeyDown={(e) => {
                        navigation3(e, 'mopActive', filteredData?.length > 0 ? `editBtn-${filteredData?.length - 1}` : 'mopActive', () => { clickElement(`mpkngMop`) })
                    }}
                />
            </Item>
            <Item className="input--wrapper" sx={sx.itemsx} style={{ width: '28%' }}>
                <LineInputV3
                    id="mopModifiedBy"
                    value={loginData?.strUserName}
                    sx={{ fontSize: '14px', fontFamily: 'Roboto', fontWeight: '500' }}
                    onBlur={(e) => { }}
                    disabled
                />
            </Item>
            <Item className="input--wrapper" sx={sx.itemsx} style={{ width: '18.2%' }}>
                <LineInputV3
                    id="mopModifiedDateTime"
                    value={moment(new Date()).format("HH:mm") + ", " + moment(new Date()).format("DD-MMM-YY")}
                    sx={{ fontSize: '14px', fontFamily: 'Roboto', fontWeight: '500', color: "#444444" }}
                    onBlur={(e) => { }}
                    disabled
                />
            </Item>
            <Item sx={sx.itemsx} style={{ width: '10%', background: '#F5FAFE', paddingLeft: '0px' }}>
                <label htmlFor="" style={{ whiteSpace: 'nowrap', fontSize: '14px', fontWeight: '500' }}>
                    <Checkbox
                        id="mopActive"
                        onKeyDown={(e) => {
                            navigation1(e, 'mopAddBtn', 'mpkngMop')
                        }}
                        style={{ paddingLeft: '9px' }}
                        checked={isActive}
                        onChange={(e) => {
                            setIsActive(e.target.checked)
                        }}
                    />
                    Active
                </label>
            </Item>
            <Button
                id="mopAddBtn"
                style={{ margin: '0', height: "40px"}}
                className="btn add-btn"
                variant="contained"
                color="error"
                onClick={() => { handleAdd() }}
                onKeyDown={(e) => {
                    navigation1(e, `editBtn-0`, 'mopActive');
                }}
            >
                add
            </Button>
        </Stack>
    </>
    )
}


const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = { getMethodOfPkngTableData, methodOfPkngDataInsert, updateAlertError }
export default connect(mapStateToProps, mapDispatchToProps)(MethodOfPackingTable)
